import { Link, useNavigate } from "react-router-dom";
import logo from "assets/png/LisapropLogo.png";
import ScrollAnimation from "components/ScrollAnimation";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <ScrollAnimation variantType="bounce">
      <footer>
        <div className="   pt-[10px] l text-[14px] ">
          <div className="mt-6 px-[20px] lg:px-[200px] lg:mt-[56px] flex flex-col lg:flex-row justify-between pb-[56px] ">
            <div className="w-full lg:w-[25%] mt-8 lg:mt-0 ">
              <img src={logo} alt="lisaprop" className="mb-4" />
              <span className="flex items-start gap-2 ">
                <p className="text-primary">Address:</p>
                <p>36, Turnbull Road, </p>
              </span>
              <p>Ikoyi, Lagos, Nigeria.</p>
              <span className="flex items-center gap-1 my-4">
                <p className="text-primary">Email:</p>
                <a href="mailto:build@lisaprop.africa">build@lisaprop.africa</a>
              </span>
              <span className="flex items-center gap-1 my-4">
                <p className="text-primary">Phone:</p>
                <a href="tel:+2348038053399">+2348038053399. </a>
              </span>
            </div>
            <div className="w-full lg:w-[40%] flex flex-col lg:flex-row gap-[56px] lg:justify-between mt-6 lg:mt-0 ">
              <div className="flex flex-col text-[14px] gap-4 items-start">
                <p className="text-primary">Company</p>
                <button onClick={() => navigate("/")}>Home</button>
                <button onClick={() => navigate("/about-us")}>About</button>
                <button onClick={() => navigate("/solutions")}>
                  Solutions
                </button>
                <button onClick={() => navigate("/contact-us")}>
                  Contact Us
                </button>
              </div>
              <div className="flex flex-col text-[14px] gap-4 items-start">
                <p className="text-primary">Legal</p>
                <button onClick={() => navigate("/terms-of-use")}>
                  Terms of service
                </button>
                <button onClick={() => navigate("/privacy-policy")}>
                  Privacy policy
                </button>
                <button onClick={() => navigate("/terms-of-use")}>
                  Cookies Policy
                </button>
                <button onClick={() => navigate("/privacy-policy")}>
                  Data Policy
                </button>
              </div>
              <div className="flex flex-col text-[14px] gap-4 items-start">
                <p className="text-primary">Socials</p>
                <button>LinkedIn</button>
                <button onClick={() => navigate("/about-us")}>Facebook</button>
                <Link to="">Twitter</Link>
                <Link
                  target="_blank"
                  to="https://www.instagram.com/lisaprop.africa?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                >
                  Instagram
                </Link>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row w-full font-[500] h-[64px] bg-[#F0F0FF] justify-center text-[14px] items-center ">
            <p className="text-primary">
              &#169; 2024 Lisaprop. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </ScrollAnimation>
  );
};

export default Footer;
